module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./UploadPictureView.js"));
	}, "UploadPictureView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=UploadPictureView!./src/pages/Promote/OfflineActivity/ActivityPicture/UploadPicture/UploadPictureView.js
// module id = 2115
// module chunks = 367